import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Route, Routes, useParams } from 'react-router'
import { currentUserSelector } from '../../../../store/selectors/userSelector'
import PerformanceConversionPaths from './PerformanceConversionPaths'
import PerformanceSalePaths from './PerformanceSalePaths'
import VerfiedSalesReport from './VerifiedSalesReport'
import CreativeReport from './CreativeReport'
import OmniConversionsReport from './Omni/OmniConversionsReport'
import ConversionsReport from './ConversionsReport'
import SummaryReport from '../Campaigns/SummaryReport'
import GA4Report from './GA4Report'

export default function Reports(): JSX.Element {
  const { agency_id } = useParams()
  const isOmni = useMemo(() => Number(agency_id) === 112, [agency_id])
  const currentUser = useSelector(currentUserSelector)

  return (
    <Routes>
      <Route path={'summary'} element={<SummaryReport />} />
      <Route path={'conversion-paths'} element={<PerformanceConversionPaths />} />
      <Route path={'sale-paths/*'} element={<PerformanceSalePaths />} />
      <Route path={'verified-sales'} element={<VerfiedSalesReport />} />
      <Route path={'creatives'} element={<CreativeReport />} />
      <Route path={'ga4'} element={<GA4Report />} />
      <Route
        path={'conversions'}
        element={isOmni ? <OmniConversionsReport /> : <ConversionsReport />}
      />
    </Routes>
  )
}
